import { render, staticRenderFns } from "./Accumulateds.vue?vue&type=template&id=142a0fec&scoped=true&"
import script from "./Accumulateds.vue?vue&type=script&lang=ts&"
export * from "./Accumulateds.vue?vue&type=script&lang=ts&"
import style0 from "./Accumulateds.vue?vue&type=style&index=0&id=142a0fec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142a0fec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
